import NiceSelect from "nice-select2";
import { tns } from 'tiny-slider/dist/tiny-slider';
import FsLightbox from "fslightbox";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelector('.breadcrumbs').scrollLeft = document.querySelector('.breadcrumbs').scrollWidth;
    initNiceSelects();
    initCarousels();
    initExpandablePanels();
    initTabs();
    moveElementOnResize('sizeChange', 'contentSize', 'detailsSource', 1024);
    moveElementOnResize('tireBadge', 'desktopBadge', 'originalContainer', 1024);
    initSmoothScroll('.panel__menu-item a', 100);
    initSmoothScroll('.content__title-rating', 100);
    initQuantityControls();
});

const initNiceSelects = () => {
    document.querySelectorAll('select').forEach(select => {
        const options = {
            searchable: !['sortProducts', 'tireYear', 'product__form-quantity'].includes(select.id),
            placeholder: 'Wybierz',
            searchtext: 'Szukaj',
            selectedtext: ' wybrano'
        };
        new NiceSelect(select, options);
    });
};

const initCarousels = () => {
    document.querySelectorAll('.products').forEach(section => {
        tns({
            container: section.querySelector('.products__carousel'),
            slideBy: 1,
            autoplay: false,
            loop: true,
            mouseDrag: true,
            nav: false,
            controlsContainer: section.querySelector('.products__nav'),
            items: 1,
            gutter: 8,
            responsive: {
                570: { items: 2, gutter: 16 },
                768: { items: 1.1, gutter: 24, edgePadding: 0 },
                1280: { gutter: 32, items: 2, edgePadding: 40, loop: true }
            }
        });
    });

    // tns({
    //     mode: 'gallery',
    //     container: '.gallery__image-carousel',
    //     items: 1,
    //     // navAsThumbnails: true,
    //     // navContainer: '.gallery__thumbs',
    //     autoplay: false,
    //     controls: false,
    //     mouseDrag: false,
    //     nav: false,
    //     axis: "horizontal"
    // });
    //
    // tns({
    //     container: '.gallery__thumbs',
    //     items: 4,
    //     loop: false,
    //     navAsThumbnails: true,
    //     axis: "vertical",
    //     nav: false,
    //     controls: false,
    //     mouseDrag: true,
    //     gutter: 16,
    //     responsive: {
    //         1024: { gutter: 8 }
    //     }
    // });
};

document.addEventListener('DOMContentLoaded', function () {
    const thumbsCarousel = document.querySelector('.gallery__thumbs .carousel');
    const imageCarousel = document.querySelector('.gallery__image .carousel');
    const thumbsItems = document.querySelectorAll('.gallery__thumbs-item');
    const imageItems = document.querySelectorAll('.gallery__image-item');
    let currentIndex = 0;
    const intervalTime = 3000;
    let autoplay;
    let startX = 0;
    let isDragging = false;
    let hasDragged = false;
    let lastInteractionTime = 0;
    const dragDelay = 500; // Delay between drag interactions in milliseconds

    const scrollUpButton = document.querySelector('.gallery__thumbs-button.up');
    const scrollDownButton = document.querySelector('.gallery__thumbs-button.down');

    function updateActiveSlide(index) {
        document.querySelector('.gallery__thumbs-item.is-active')?.classList.remove('is-active');
        document.querySelector('.gallery__image-item.is-active')?.classList.remove('is-active');

        thumbsItems[index].classList.add('is-active');
        imageItems.forEach((item, idx) => {
            item.style.transition = 'transform 0.5s ease-in-out';
            item.style.transform = `translateX(-${index * 100}%)`;
            if (idx === index) {
                item.classList.add('is-active');
            } else {
                item.classList.remove('is-active');
            }
        });

        if (thumbsCarousel.scrollHeight > thumbsCarousel.clientHeight) {
            thumbsCarousel.scrollTo({
                top: thumbsItems[index].offsetTop - thumbsCarousel.clientHeight / 2 + thumbsItems[index].clientHeight / 2,
                behavior: 'smooth'
            });
        } else if (thumbsCarousel.scrollWidth > thumbsCarousel.clientWidth) {
            thumbsCarousel.scrollTo({
                left: thumbsItems[index].offsetLeft - thumbsCarousel.clientWidth / 2 + thumbsItems[index].clientWidth / 2,
                behavior: 'smooth'
            });
        }

        if (index === 0) {
            scrollUpButton.classList.add('disabled');
        } else {
            scrollUpButton.classList.remove('disabled');
        }

        if (index === thumbsItems.length - 1) {
            scrollDownButton.classList.add('disabled');
        } else {
            scrollDownButton.classList.remove('disabled');
        }
    }

    scrollUpButton.addEventListener('click', () => {
        if (window.innerWidth > 480) {
            thumbsCarousel.scrollBy({ top: -64, behavior: 'smooth' });
        } else {
            thumbsCarousel.scrollBy({ left: -48, behavior: 'smooth' });
        }
    });

    scrollDownButton.addEventListener('click', () => {
        if (window.innerWidth > 480) {
            thumbsCarousel.scrollBy({ top: 64, behavior: 'smooth' });
        } else {
            thumbsCarousel.scrollBy({ left: 48, behavior: 'smooth' });
        }
    });

    imageCarousel.addEventListener('mousedown', (e) => {
        stopAutoplay();
        startX = e.clientX;
        isDragging = true;
        hasDragged = false;
    });

    imageCarousel.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        let deltaX = e.clientX - startX;
        if (Math.abs(deltaX) > 50) {
            hasDragged = true;
            if (deltaX > 0) {
                prevSlide();
            } else {
                nextSlide();
            }
            isDragging = false;
        }
    });

    imageCarousel.addEventListener('mouseup', () => {
        isDragging = false;
    });

    imageCarousel.addEventListener('mouseleave', () => {
        isDragging = false;
    });

    function nextSlide() {
        currentIndex = (currentIndex + 1) % imageItems.length;
        updateActiveSlide(currentIndex);
    }

    function prevSlide() {
        currentIndex = (currentIndex - 1 + imageItems.length) % imageItems.length;
        updateActiveSlide(currentIndex);
    }

    function startAutoplay() {
        autoplay = setInterval(nextSlide, intervalTime);
    }

    function stopAutoplay() {
        clearInterval(autoplay);
    }

    thumbsItems.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
            stopAutoplay();
            currentIndex = index;
            updateActiveSlide(currentIndex);
        });
    });

    updateActiveSlide(currentIndex);
    startAutoplay();
});


const initExpandablePanels = () => {
    const headerHeight = document.querySelector('.header').offsetHeight;
    const expandablePanels = document.querySelectorAll('.panel__content.expandable');

    expandablePanels.forEach(panel => {
        const content = panel.querySelector('.panel__content-content');
        if (content) content.style.display = 'none';

        const title = panel.querySelector('.panel__content-title');
        if (title) {
            title.addEventListener('click', () => {
                expandablePanels.forEach(p => {
                    if (p !== panel) {
                        const otherContent = p.querySelector('.panel__content-content');
                        if (otherContent) {
                            otherContent.style.display = 'none';
                            p.querySelector('span').textContent = '+';
                        }
                    }
                });

                if (content.style.display === 'none') {
                    content.style.display = 'block';
                    title.querySelector('span').textContent = '-';
                    const panelTop = panel.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                    window.scrollTo({ top: panelTop, behavior: 'smooth' });
                } else {
                    content.style.display = 'none';
                    title.querySelector('span').textContent = '+';
                }
            });
        }
    });
};

const initTabs = () => {
    document.querySelectorAll('.tabs__content-title').forEach(title => {
        title.addEventListener('click', () => {
            const parent = title.parentElement;
            const span = title.querySelector('span');
            parent.classList.toggle('hidden');
            span.textContent = parent.classList.contains('hidden') ? '+' : '-';
            document.querySelectorAll('.tabs__content').forEach(tab => {
                if (tab !== parent) {
                    tab.classList.add('hidden');
                    tab.querySelector('.tabs__content-title span').textContent = '+';
                }
            });
        });
    });
};

const moveElementOnResize = (elementId, desktopDestinationId, mobileSourceId, breakpoint) => {
    const moveElement = () => {
        const elementToMove = document.getElementById(elementId);
        const destination = document.getElementById(desktopDestinationId);
        const source = document.getElementById(mobileSourceId);

        if (window.innerWidth >= breakpoint) {
            if (elementToMove && destination && !destination.contains(elementToMove)) {
                destination.appendChild(elementToMove);
            }
        } else {
            if (elementToMove && source && !source.contains(elementToMove)) {
                source.appendChild(elementToMove);
            }
        }
    };

    moveElement();
    window.addEventListener('resize', moveElement);
};

const initSmoothScroll = (selector, offset) => {
    document.querySelectorAll(selector).forEach(anchor => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = anchor.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        });
    });
};

const initQuantityControls = () => {
    const decrementButton = document.querySelector('.content__quantity-button--decrement');
    const incrementButton = document.querySelector('.content__quantity-button--increment');
    const quantityInput = document.querySelector('.content__quantity-input');

    const updateInputValue = (value) => {
        quantityInput.value = `${value} szt.`;
    };

    const getInputValue = () => {
        const value = parseInt(quantityInput.value.replace(' szt.', ''));
        return isNaN(value) || value < 1 ? 1 : value;
    };

    decrementButton.addEventListener('click', () => {
        let currentValue = getInputValue();
        if (currentValue > 1) updateInputValue(currentValue - 1);
    });

    incrementButton.addEventListener('click', () => {
        let currentValue = getInputValue();
        updateInputValue(currentValue + 1);
    });

    quantityInput.addEventListener('input', () => {
        let currentValue = getInputValue();
        updateInputValue(currentValue);
    });

    quantityInput.addEventListener('blur', () => {
        let currentValue = getInputValue();
        updateInputValue(currentValue);
    });

    updateInputValue(getInputValue());
};